/**
 * Espelha VincularOportunidadeVendaRequest do OrquestradorVendas (POST ProcessoVenda/idVenda/{idVenda}/oportunidade/vincular).
 * A tela manda só a oportunidade: o código (texto da ocorrência) e o escopo do vendedor são preenchidos pelo
 * orquestrador, que sobrescreve o que viesse daqui.
 */
export class VincularOportunidadeVendaRequest {
  public idOportunidade: number;
}
